<template>
  <div class="app-dialog-actions flex flex-col-reverse gap-2 md:flex-row md:justify-between">
    <div class="flex flex-col-reverse gap-2 md:flex-row md:gap-2">
      <slot name="secondary">
        <VaButton v-if="showCancel" preset="secondary" :disabled="loading" @click="emit('cancel')">
          {{ cancelLabel }}
        </VaButton>
      </slot>
    </div>
    <div class="flex flex-col-reverse gap-2 md:flex-row md:gap-2 md:justify-end">
      <slot name="primary">
        <VaButton
          v-if="showPrimary"
          :preset="primaryPreset"
          :color="primaryColor"
          :loading="loading"
          :disabled="primaryDisabled"
          @click="emit('primary')"
        >
          {{ primaryLabel }}
        </VaButton>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { VaButton } from 'vuestic-ui'

withDefaults(
  defineProps<{
    cancelLabel?: string
    primaryLabel?: string
    showCancel?: boolean
    showPrimary?: boolean
    loading?: boolean
    primaryDisabled?: boolean
    primaryPreset?: string
    primaryColor?: string
  }>(),
  {
    cancelLabel: 'Cancel',
    primaryLabel: 'Confirm',
    showCancel: true,
    showPrimary: true,
    loading: false,
    primaryDisabled: false,
    primaryPreset: 'primary',
    primaryColor: undefined,
  },
)

const emit = defineEmits<{
  cancel: []
  primary: []
}>()
</script>
